import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useCallback } from 'react';

import { closeToast } from 'reducers/toastReducer';


import './ToastManager.css';


const Toast = (props) => {
	const dispatch = useDispatch();

	const close = useCallback(() => {
		dispatch(closeToast(props.id));
	}, [dispatch, props.id]);

	useEffect(() => {
		const timer = setTimeout(() => {
			close();
		}, 5000); // Auto-dismiss after 5 seconds

		return () => clearTimeout(timer);
	}, [close]);

	// Determine toast styling based on type
	// v3 toasts: white card with a colored accent per type (ToastManager.css)
	const getToastClasses = () => {
		let baseClasses = 'toast show v3-toast';
		if (props.type === 'success') {
			baseClasses += ' v3-toast-success';
		} else if (props.type === 'error') {
			baseClasses += ' v3-toast-error';
		} else if (props.type === 'warning') {
			baseClasses += ' v3-toast-warning';
		}
		return baseClasses;
	};

	// Get icon based on type
	const getIcon = () => {
		if (props.type === 'success') return 'bi-check-circle';
		if (props.type === 'error') return 'bi-exclamation-triangle';
		if (props.type === 'warning') return 'bi-exclamation-circle';
		return 'bi-info-circle';
	};

	return (
		<div className={getToastClasses()}>
			<div className="toast-header">
				<i className={`bi ${getIcon()} me-2`}></i>
				<strong className="me-auto">{props.title}</strong>
				<button type="button" className="btn-close" onClick={close} aria-label="Close" />
			</div>
			<div className="toast-body">
				{props.body}
			</div>
		</div>
	);
}

const ToastManager = (props) => {
	const {
		toasts,
	} = useSelector(state => ({
		toasts: state.toast.items,
	}));

	return (
		<div className="toast-manager" style={{position: 'fixed', top: '20px', right: '20px', zIndex: 9999}}>
			<div className="toast-container">
				{toasts.map(toast => <Toast key={toast.id} {...toast} />)}
			</div>
		</div>
	);
};

export default ToastManager;
